import { navigate } from 'hookrouter'
import React, { FC } from 'react'
import { ListGroup } from 'react-bootstrap'
import { ProjectRolesParam, userRoles } from 'types'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
import { toast } from 'react-toastify';

export const ProjectRolesList: FC<ProjectRolesParam> = ({
  companyId,
  projectId,
  templateDocumentId
}) => {

  const projectList = useProjectsForCompany(companyId)
  const selectedProject:any =  projectList.find((company:any) => company.id === projectId) || {};

  const showErrorMessage = (text:any)=>{
    toast.error(text, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    });
  }
  return (
  <>
    <div style= {{width: '128%'}}>
      <div><h3 style={{ fontSize:'21px' }}>Manage Role</h3></div>
      <ListGroup as="ul">
          {userRoles.map(role => {
            return (
              <ListGroup.Item
                as="li"
                key={role.id}
                onClick={() => {selectedProject?.status =='active' ? navigate(`/company/${companyId}/project/${projectId}/projectUsersList/${role.id}`,true, { 'templateDocumentId': templateDocumentId }) : showErrorMessage('You are not allowed to view this List')}}>
                <svg className="svg-icon" viewBox="0 0 20 20" style={{width: '20px', marginTop: '-4px'}}>
							  <path d="M12.075,10.812c1.358-0.853,2.242-2.507,2.242-4.037c0-2.181-1.795-4.618-4.198-4.618S5.921,4.594,5.921,6.775c0,1.53,0.884,3.185,2.242,4.037c-3.222,0.865-5.6,3.807-5.6,7.298c0,0.23,0.189,0.42,0.42,0.42h14.273c0.23,0,0.42-0.189,0.42-0.42C17.676,14.619,15.297,11.677,12.075,10.812 M6.761,6.775c0-2.162,1.773-3.778,3.358-3.778s3.359,1.616,3.359,3.778c0,2.162-1.774,3.778-3.359,3.778S6.761,8.937,6.761,6.775 M3.415,17.69c0.218-3.51,3.142-6.297,6.704-6.297c3.562,0,6.486,2.787,6.705,6.297H3.415z"></path>
						</svg>
                <span style={{ padding: '10px' }}>{role.name}</span>
                <svg className="svg-icon" viewBox="0 0 20 20" style={{width: '17px', marginTop: '4px', float: 'right'}}>
                  <path d="M12.522,10.4l-3.559,3.562c-0.172,0.173-0.451,0.176-0.625,0c-0.173-0.173-0.173-0.451,0-0.624l3.248-3.25L8.161,6.662c-0.173-0.173-0.173-0.452,0-0.624c0.172-0.175,0.451-0.175,0.624,0l3.738,3.736C12.695,9.947,12.695,10.228,12.522,10.4 M18.406,10c0,4.644-3.764,8.406-8.406,8.406c-4.644,0-8.406-3.763-8.406-8.406S5.356,1.594,10,1.594C14.643,1.594,18.406,5.356,18.406,10M17.521,10c0-4.148-3.374-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.147,17.521,10"></path>
              </svg>
                {/* <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg> */}
              </ListGroup.Item>
            )
          })}
      </ListGroup>
      <br/>
    </div>
  </>
  )
}
